<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="F20" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g715t543x5j31hc0rsgr0.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g715t5n0qdj31hc0rswij.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g715t6agj6j31hc0rs767.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g715t6pqumj31hc0rs76b.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g715t797b9j31hc0rs42u.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g715t7quenj31hc0rsdhg.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g715t8e42wj31hc0rsmzh.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g715t90lglj31hc0rstcg.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g715t9mo8rj31hc0rs0uh.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g715ta2pd2j31hc0rs776.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g715tak4xhj31hc0rsjt0.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g715tb000gj31hc0rswj7.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g715tbxljlj31hc0rs764.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g715tsm8ukj30ku0rsmyq.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g715tt11l8j30ku0rsq57.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g715tthuq0j30ku0rs75d.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g715ttyncpj30ku0rs0uy.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/mw690/0067mezugy1g715turuy2j30ku0rsgo3.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g715tv95c6j30ku0rsq4g.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g715tvp536j30ku0rstbp.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g715twbk73j30ku0rsq3p.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g715twtjf5j30ku0rs3zq.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones3: ["http://wx4.sinaimg.cn/large/0067mezugy1g5r898nggyj306b0h3q2z.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r8991ecjj30630gk3yl.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r899fy3zj30640dw0so.jpg"],
            earphones2: ["http://wx3.sinaimg.cn/large/0067mezugy1g5r89ahq8zj30690gy0su.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g5r89b5y4xj30670g4q33.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r89cagpcj30640dwmx5.jpg"],
            earphones1: ["http://wx1.sinaimg.cn/large/0067mezugy1g5r8creyqej306a0h0aa5.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5r8cs3r4gj306l0h1q33.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5r8cskyewj30640dw0sp.jpg"],
            clientWidth: document.body.clientWidth
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    },
    beforeMount(){
        window.addEventListener("resize", () => {
            this.clientWidth = document.body.clientWidth
        })
    }
}
</script>
<style scoped>

.pro_color_box li:nth-child(1) i::before{
	background: #015f84;
}

.pro_color_box li:nth-child(2) i::before{
	background: #e7212a;
}

.pro_color_box li:nth-child(3) i::before{
	background: #342c2a;
}

@media (max-width: 768px) {
    
    /* .pro_animation_item img{
		width: 4.2667rem;
	} */
}
</style>



// WEBPACK FOOTER //
// src/pages/products/F/f20.vue